var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapseIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "black",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8582 9.57107L16.8582 14.5711C16.8582 15.1234 17.3059 15.5711 17.8582 15.5711H22.8582C23.4104 15.5711 23.8582 15.1234 23.8582 14.5711C23.8582 14.0188 23.4104 13.5711 22.8582 13.5711L23.5653 13.5711H20.2724L24.2221 9.62132C24.6126 9.2308 24.6126 8.59763 24.2221 8.20711C23.8316 7.81658 23.1984 7.81658 22.8079 8.20711L18.8582 12.1569L18.8582 9.57107C18.8582 9.01878 18.4104 8.57107 17.8582 8.57107C17.3059 8.57107 16.8582 9.01878 16.8582 9.57107Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.571 22.8684L15.571 17.8684C15.571 17.3161 15.1233 16.8684 14.571 16.8684L9.57104 16.8684C9.01875 16.8684 8.57104 17.3161 8.57104 17.8684C8.57104 18.4207 9.01875 18.8684 9.57104 18.8684L12.1568 18.8684L8.20708 22.8181C7.81655 23.2087 7.81655 23.8418 8.20708 24.2323C8.5976 24.6229 9.23077 24.6229 9.62129 24.2323L13.571 20.2826L13.571 22.8684C13.571 23.4207 14.0188 23.8684 14.571 23.8684C15.1233 23.8684 15.571 23.4207 15.571 22.8684Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseIcon);
export default __webpack_public_path__ + "static/media/collapse-icon.b14fd297e94cfb711ebe7763e6d31cc3.svg";
export { ForwardRef as ReactComponent };